/* Sapone Di Toscana – geurquiz
 * Eén engine voor de quizpagina (en de popup verwijst naar diezelfde pagina).
 * De koppeling antwoord -> geur staat per geur in het metaobject (velden quiz_q1, quiz_q2, quiz_q3),
 * niet in deze code. Producten worden gekoppeld via de geur, niet via titel of vaste ID.
 */
(function (root) {
  'use strict';

  /**
   * Bereken de uitslag.
   * @param {Array} fragrances  [{handle, q1:[keys], q2:[keys], q3:[keys], ...}]
   * @param {Object} answers    {q1:'key', q2:'key', q3:'key'}
   * @param {Object} weights    {q1:50, q2:30, q3:20}
   * @returns {{candidates: Array, winners: Array, top: number}}
   */
  function scoreQuiz(fragrances, answers, weights) {
    var w = weights || { q1: 50, q2: 30, q3: 20 };
    var candidates = fragrances
      .filter(function (f) { return (f.q1 || []).indexOf(answers.q1) !== -1; })
      .map(function (f, i) {
        var s = w.q1;
        if ((f.q2 || []).indexOf(answers.q2) !== -1) s += w.q2;
        if ((f.q3 || []).indexOf(answers.q3) !== -1) s += w.q3;
        return { fragrance: f, score: s, order: i };
      })
      .sort(function (a, b) { return b.score - a.score || a.order - b.order; });
    var top = candidates.length ? candidates[0].score : 0;
    var winners = candidates.filter(function (c) { return c.score === top; });
    return { candidates: candidates, winners: winners, top: top };
  }

  root.SDTQuizEngine = { scoreQuiz: scoreQuiz };
  if (typeof module !== 'undefined' && module.exports) module.exports = { scoreQuiz: scoreQuiz };

  if (typeof window === 'undefined' || typeof customElements === 'undefined') return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Teksten komen uit de locale-bestanden (window.sdtStrings, zie layout/theme.liquid); Nederlands is de terugvaloptie. */
  function S(key, fallback) { var o = window.sdtStrings; return o && typeof o[key] === 'string' ? o[key] : fallback; }
  function fmt(str, map) { return str.replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }

  class SDTQuiz extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('script[data-sdt-quiz]');
      if (!dataEl) return;
      this.data = JSON.parse(dataEl.textContent);
      this.step = 0;
      this.answers = {};
      this.panel = this.querySelector('[data-quiz-panel]');
      this.resultEl = this.querySelector('[data-quiz-result]');
      this.liveEl = this.querySelector('[data-quiz-live]');
      this.newsletterEl = this.querySelector('[data-quiz-newsletter]');
      this.render();
      if (this.newsletterEl && (/customer_posted/.test(location.search) || location.hash === '#SdtQuizNewsletter' || this.newsletterEl.querySelector('[role=alert]'))) {
        this.newsletterEl.hidden = false;
      }
    }

    keys() { return ['q1', 'q2', 'q3']; }

    render() {
      var q = this.data.questions[this.step];
      var key = this.keys()[this.step];
      var total = this.data.questions.length;
      var self = this;
      var html = '';
      html += '<div class="sdt-quiz__progress"><span>' + esc(fmt(S('quizStep', 'Vraag [current] van [total]'), { current: this.step + 1, total: total })) + '</span>';
      html += '<div class="sdt-quiz__bar" aria-hidden="true"><span style="width:' + Math.round(((this.step + 1) / total) * 100) + '%"></span></div></div>';
      html += '<form novalidate data-quiz-form><fieldset><legend tabindex="-1">' + esc(q.title) + '</legend>';
      if (q.subtitle) html += '<p class="sdt-quiz__sub">' + esc(q.subtitle) + '</p>';
      html += '<div class="sdt-quiz__options">';
      q.answers.forEach(function (a, i) {
        var id = 'sdt-q-' + key + '-' + a.key;
        var checked = self.answers[key] === a.key ? ' checked' : '';
        html += '<div class="sdt-quiz__option"><input type="radio" name="' + key + '" id="' + id + '" value="' + esc(a.key) + '"' + checked + '>';
        html += '<label for="' + id + '"><strong>' + esc(a.label) + '</strong>' + (a.description ? '<span>' + esc(a.description) + '</span>' : '') + '</label></div>';
      });
      html += '</div></fieldset>';
      html += '<p class="sdt-quiz__error" data-quiz-error hidden role="alert">' + esc(S('quizChooseAnswer', 'Kies een antwoord om verder te gaan.')) + '</p>';
      html += '<div class="sdt-quiz__nav">';
      html += '<button type="button" class="button button--secondary" data-quiz-prev' + (this.step === 0 ? ' disabled' : '') + '>' + esc(S('quizPrev', 'Vorige')) + '</button>';
      html += '<button type="submit" class="button">' + esc(this.step === total - 1 ? S('quizShowResult', 'Toon mijn geur') : S('quizNext', 'Volgende')) + '</button>';
      html += '</div></form>';
      this.panel.innerHTML = html;
      this.panel.hidden = false;
      this.resultEl.hidden = true;
      if (this.newsletterEl && this.answers && !Object.keys(this.answers).length && !/customer_posted/.test(location.search)) this.newsletterEl.hidden = true;

      var form = this.panel.querySelector('[data-quiz-form]');
      form.addEventListener('submit', function (e) { e.preventDefault(); self.next(form); });
      this.panel.querySelector('[data-quiz-prev]').addEventListener('click', function () { self.prev(form); });
      form.addEventListener('change', function () { self.panel.querySelector('[data-quiz-error]').hidden = true; });
    }

    focusLegend() {
      var lg = this.panel.querySelector('legend');
      if (lg) lg.focus({ preventScroll: false });
    }

    store(form) {
      var key = this.keys()[this.step];
      var checked = form.querySelector('input[name="' + key + '"]:checked');
      if (checked) this.answers[key] = checked.value;
      return !!checked;
    }

    next(form) {
      if (!this.store(form)) {
        var err = this.panel.querySelector('[data-quiz-error]');
        err.hidden = false;
        var first = form.querySelector('input');
        if (first) first.focus();
        return;
      }
      if (this.step < this.data.questions.length - 1) {
        this.step++;
        this.render();
        this.focusLegend();
      } else {
        this.showResult();
      }
    }

    prev(form) {
      this.store(form);
      if (this.step > 0) { this.step--; this.render(); this.focusLegend(); }
    }

    reset() {
      this.step = 0;
      this.answers = {};
      this.render();
      this.focusLegend();
    }

    card(c, total) {
      var f = c.fragrance;
      var pct = Math.round((c.score / total) * 100);
      var media = f.image
        ? '<img src="' + esc(f.image) + '" alt="' + esc(f.name) + '" width="600" height="750" loading="lazy">'
        : '';
      var h = '<article class="sdt-match">';
      h += '<div class="sdt-match__media">' + media + '</div><div>';
      h += '<span class="sdt-match__score">' + esc(fmt(S('quizMatch', '[percent]% match'), { percent: pct })) + '</span>';
      h += '<h3 class="h3">' + esc(f.name) + '</h3>';
      if (f.profile) h += '<p class="sdt-match__profile">' + fmt(esc(S('quizProfile', 'Geurprofiel: [profile]')), { profile: esc(f.profile) }) + '</p>';
      if (f.result) h += '<p>' + esc(f.result) + '</p>';
      if (f.url) {
        h += '<div class="sdt-actions"><a class="button" href="' + esc(f.url) + '">' + fmt(esc(S('quizView', 'Bekijk [name]')), { name: esc(f.name) }) + '</a></div>';
        if (f.available === false) {
          h += '<p class="sdt-match__stock sdt-match__stock--out">' + fmt(S('quizSoldOut', 'Deze geur is op dit moment uitverkocht. Op de productpagina zie je wanneer hij weer beschikbaar is, of neem <a href="[contact_url]">contact</a> met ons op.'), { contact_url: esc(this.data.contactUrl) }) + '</p>';
        } else if (f.price) {
          h += '<p class="sdt-match__stock">' + esc(f.price) + (f.size ? ' · ' + esc(f.size) : '') + '</p>';
        }
      } else {
        h += '<p class="sdt-match__stock">' + fmt(S('quizNotOnline', 'Deze geur is nog niet online te bestellen. <a href="[collection_url]">Bekijk het beschikbare assortiment</a> of neem <a href="[contact_url]">contact</a> met ons op.'), { collection_url: esc(this.data.collectionUrl), contact_url: esc(this.data.contactUrl) }) + '</p>';
      }
      h += '</div></article>';
      return h;
    }

    showResult() {
      var eyebrow = '<p class="sdt-eyebrow">' + esc(S('quizEyebrow', 'Jouw geuradvies')) + '</p>';
      var w = this.data.weights;
      var total = w.q1 + w.q2 + w.q3;
      var r = scoreQuiz(this.data.fragrances, this.answers, w);
      var self = this;
      var h = '<div class="sdt-result__intro">';
      if (r.winners.length > 1) {
        h += eyebrow + '<h2 class="h2">' + esc(this.data.tieHeading) + '</h2><p>' + esc(this.data.tieText) + '</p>';
      } else {
        h += eyebrow + '<h2 class="h2">' + esc(this.data.singleHeading) + '</h2>';
      }
      h += '</div>';
      h += '<div class="sdt-result__grid sdt-result__grid--' + (r.winners.length > 1 ? '2' : '1') + '">';
      r.winners.forEach(function (c) { h += self.card(c, total); });
      h += '</div>';
      var others = r.candidates.filter(function (c) { return c.score < r.top; });
      if (others.length) {
        h += '<p class="sdt-result__others">' + esc(S('quizAlsoMatching', 'Ook passend bij jouw voorkeur:')) + ' ';
        h += others.map(function (c) {
          var name = esc(c.fragrance.name) + ' (' + esc(fmt(S('quizMatch', '[percent]% match'), { percent: Math.round((c.score / total) * 100) })) + ')';
          return c.fragrance.url ? '<a class="sdt-link-arrow" href="' + esc(c.fragrance.url) + '">' + name + '</a>' : name;
        }).join(', ');
        h += '</p>';
      }
      h += '<p class="sdt-result__note">' + esc(this.data.note) + '</p>';
      h += '<div class="sdt-actions" style="justify-content:center"><button type="button" class="button button--secondary" data-quiz-restart>' + esc(S('quizRestart', 'Opnieuw beginnen')) + '</button>';
      h += '<a class="button button--tertiary" href="' + esc(this.data.collectionUrl) + '">' + esc(S('quizViewAll', 'Alle geuren bekijken')) + '</a></div>';

      var target = this.resultEl.querySelector('[data-quiz-result-content]');
      target.innerHTML = h;
      this.panel.hidden = true;
      this.resultEl.hidden = false;
      if (this.newsletterEl) this.newsletterEl.hidden = false;
      target.querySelector('[data-quiz-restart]').addEventListener('click', function () { self.reset(); });
      var heading = target.querySelector('h2');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus(); }
      if (this.liveEl) this.liveEl.textContent = fmt(S('quizLiveDone', 'Je geuradvies is klaar: [names]'), { names: r.winners.map(function (c) { return c.fragrance.name; }).join(' ' + S('quizAnd', 'en') + ' ') });
      try { sessionStorage.setItem('sdt-quiz-done', '1'); } catch (e) { /* geen opslag beschikbaar */ }
    }
  }

  if (!customElements.get('sdt-quiz')) customElements.define('sdt-quiz', SDTQuiz);
})(typeof window !== 'undefined' ? window : globalThis);
